import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as DropDownIcon } from 'Assets/svg/dropdown-icon.svg';
import { ReactComponent as CalenderIcon } from 'Assets/usageAnalytics/calendar-icon.svg';
import { ReactComponent as RightArrowIcon } from 'Assets/usageAnalytics/right-arrow.svg';
import MonthRangeDropdown from './monthRangeDropdown/monthRangeDropdown';

const monthsDropDown = [
  { label: 'Current Month' },
  { label: 'Current + Last 1 Month' },
  { label: 'Current + Last 2 Months' },
  { label: 'Custom Date Range ' },
];

const CustomRangeSelection = props => {
  const {
    fetchUsageAnalytics,
    getMonthRangeFromDropDown,
    isEnterpriseAdmin,
    currentTab = 0,
    getPreviousMonthData,
    getMonthRange,
  } = props;
  const currentDate = new Date();

  const customDateRangeRef = useRef(null);
  const monthRangeRef = useRef();
  const [monthsDropDownPopup, setMonthsDropDownPopup] = useState(false);
  const [calenderPopup, setCalendarPopUp] = useState(false);
  const [monthsValue, setMonthsValue] = useState(monthsDropDown[3].label);
  const [monthRange, setMonthRange] = useState(
    getMonthRange(getPreviousMonthData(currentDate, 10)),
  );

  const handleOnClickDropDown = () => {
    setMonthsDropDownPopup(!monthsDropDownPopup);
  };

  function handleClickOutside(event) {
    if (
      monthRangeRef.current &&
      !monthRangeRef.current?.contains(event.target) &&
      calenderPopup
    )
      setCalendarPopUp(false);

    if (
      customDateRangeRef.current &&
      !customDateRangeRef.current?.contains(event.target) &&
      monthsDropDownPopup
    )
      setMonthsDropDownPopup(false);
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (calenderPopup) {
      // eslint-disable-next-line no-undef
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        // eslint-disable-next-line no-undef
        document.removeEventListener('click', handleClickOutside, true);
      };
    }

    if (monthsDropDownPopup) {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        // eslint-disable-next-line no-undef
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
  }, [calenderPopup, monthsDropDownPopup]);

  useEffect(() => {
    setMonthsValue(monthsDropDown[3].label);
  }, [currentTab]);

  return (
    <span
      className="months-drop-down custom-date-range"
      ref={customDateRangeRef}
    >
      <span onClick={handleOnClickDropDown}>
        <CalenderIcon onClick={handleOnClickDropDown} />
        <div onClick={handleOnClickDropDown}>
          {monthsValue !== monthsDropDown[3].label
            ? monthsValue
            : `${monthRange.startMonth.slice(0, 3)} ${monthRange.startYear} -  
                  ${monthRange.endMonth.slice(0, 3)} ${monthRange.endYear}`}
        </div>
        <DropDownIcon onClick={handleOnClickDropDown} />
      </span>
      {monthsDropDownPopup === true && (
        <div className="custom-data-range-options">
          {monthsDropDown.map((ele, i) => {
            if (i < 3)
              return (
                <div
                  onClick={() => {
                    getMonthRangeFromDropDown(ele.label);
                    setMonthsValue(ele.label);
                    setMonthsDropDownPopup(false);
                  }}
                  key={i}
                >
                  {ele.label}
                </div>
              );
            return (
              <div
                onClick={() => {
                  setMonthsValue(ele.label);
                  setCalendarPopUp(true);
                }}
                key={i}
              >
                <span>{ele.label}</span>
                <RightArrowIcon />
              </div>
            );
          })}
        </div>
      )}
      {calenderPopup === true && (
        <div className="calender-tool-tip" ref={monthRangeRef}>
          <MonthRangeDropdown
            maxRange={currentTab === 0 ? 10 : 6}
            onApply={data => {
              setMonthRange(data);
              setMonthsDropDownPopup(false);
              fetchUsageAnalytics(data);
            }}
            valueForNotAdmin={isEnterpriseAdmin ? 'Admin' : 'notAdmin'}
            defaultValue={monthRange}
            onClose={() => {
              setCalendarPopUp(false);
            }}
          />
        </div>
      )}
    </span>
  );
};

export default CustomRangeSelection;
